export default "__VITE_ASSET__debc6e48__"